import { ShippingIcon } from '../../icons/ShippingIcon';
import { StoreIcon } from '../../icons/StoreIcon';
import {
  CostRow,
  MessageBox,
  MethodHeading,
  MethodIcon,
  MethodLabel,
  MethodOption,
  MethodPrice,
  MethodRow,
  Wrapper,
} from './DeliveryStep.styles';
import { RadioControl } from '../../components/RadioButton';
import type { DeliveryStepLabels, DeliveryStepProps } from './DeliveryStep.types';

const DEFAULT_LABELS: Required<DeliveryStepLabels> = {
  chooseMethod: 'Choose your delivery method',
  methodPostal: 'Postal delivery',
  methodCollection: 'Click & collect',
};

export function DeliveryStep({
  values,
  onMethodChange,
  isPostalAllowed = true,
  isCollectionAllowed = true,
  postalCost,
  collectionDetails,
  labels,
}: DeliveryStepProps) {
  const merged = { ...DEFAULT_LABELS, ...labels };
  const isPostal = values.method === 'post';

  return (
    <Wrapper data-testid="delivery-step">
      <MethodHeading>{merged.chooseMethod}</MethodHeading>

      <MethodRow role="radiogroup" aria-label={merged.chooseMethod}>
        {isCollectionAllowed && (
          <MethodOption data-selected={!isPostal}>
            <RadioControl
              type="radio"
              name="deliveryMethod"
              value="collection"
              checked={!isPostal}
              onChange={() => onMethodChange('collection')}
              aria-label={merged.methodCollection}
            />
            <MethodIcon>
              <StoreIcon size={20} />
            </MethodIcon>
            <MethodLabel>{merged.methodCollection}</MethodLabel>
          </MethodOption>
        )}
        {isPostalAllowed && (
          <MethodOption data-selected={isPostal}>
            <RadioControl
              type="radio"
              name="deliveryMethod"
              value="post"
              checked={isPostal}
              onChange={() => onMethodChange('post')}
              aria-label={merged.methodPostal}
            />
            <MethodIcon>
              <ShippingIcon size={25} />
            </MethodIcon>
            <MethodLabel>{merged.methodPostal}</MethodLabel>
            {postalCost?.price && <MethodPrice>{postalCost.price}</MethodPrice>}
          </MethodOption>
        )}
      </MethodRow>

      {isPostal && postalCost && (
        <MessageBox>
          <CostRow>
            <span>{postalCost.label}</span>
            <span>{postalCost.price}</span>
          </CostRow>
        </MessageBox>
      )}
      {!isPostal && collectionDetails && (
        <MessageBox>
          <span>{collectionDetails}</span>
        </MessageBox>
      )}
    </Wrapper>
  );
}
